export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageHeader.vue?vue&type=template&id=a2c802fe&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageHeader.vue?vue&type=template&id=a2c802fe&scoped=true
// module id = 102
// module chunks = 0